if ($('.admin-logged').length) {
    function parseDate(dateString) {
        const [day, month, year] = dateString.split('.').map(part => parseInt(part, 10));
        return new Date(year, month - 1, day);
    }

    $(document).ready(function() {
        $.ajax({
            url: '/user/documents/code_listFinal.json?v=' + new Date().getMinutes(),
            dataType: 'json',
        }).done(function(data) {
            var url = window.location.href;
            var domain = url.split('//')[1].split('/')[0];
            var domainWithoutWWW = domain.replace('www.', '');
            var storageName = 'CuponData_' + domainWithoutWWW;
            var storedData = {};

            data.forEach(function(rowData) {
                if (rowData.templateTitle && rowData.templateTitle.includes('#sablona')) {
                    var couponCode = rowData.code;
                    if (couponCode && couponCode.trim() !== '') {
                        storedData[couponCode] = rowData;
                    }
                }
            });

            sessionStorage.setItem(storageName, JSON.stringify(storedData));

            function checkCouponCategory() {
                var storedData = sessionStorage.getItem(storageName);
                if (storedData) {
                    storedData = JSON.parse(storedData);

                    var currentCategory;
                    if ($('.type-category').length) {
                        currentCategory = getShoptetDataLayer('category').path;
                    }
                    if ($('.type-detail').length) {
                        currentCategory = getShoptetDataLayer('product').currentCategory.split('|').map(function(item) {
                            return item.trim();
                        });
                    }

                    function parseDate(dateString) {
                        var parts = dateString.split('.');
                        return new Date(parts[2], parts[1] - 1, parts[0]);
                    }

                    for (var couponCode in storedData) {
                        var couponData = storedData[couponCode];

                        // Only proceed if templateTitle contains '#sablona'
                        if (!couponData.templateTitle.includes('#sablona')) {
                            continue;
                        }

                        var categories = couponData.category.map(function(item) {
                            return item.trim();
                        });

                        var isCategoryMatch = categories.some(function(category) {
                            return currentCategory.includes(category);
                        });
                        
                        if (isCategoryMatch) {
                            
                            var alreadyDisplayed = false;
                            $('.products .product').each(function() {
                                if ($(this).find('.customCode').length > 0) {
                                    alreadyDisplayed = true;
                                    return false;
                                }
                            });

                            if (alreadyDisplayed) {
                                continue;
                            }

                            $('.products .product').each(function() {
                                var price = $(this).find('div[data-micro="offer"]').attr('data-micro-price');
                                var currentDate = new Date();
                                var validFrom = new Date(parseDate(couponData.validFrom));
                                var validUntil = new Date(parseDate(couponData.validUntil));

                                if (currentDate >= validFrom && currentDate <= validUntil) {
                                    var CuponPrice;
                                    if (couponData.type === 'percentual') {
                                        CuponPrice = parseFloat(price) - ((parseFloat(couponData.discount) / 100) * parseFloat(price));
                                    } else {
                                        CuponPrice = parseFloat(price) - parseFloat(couponData.discount);
                                    }

                                    $(this).find('.prices').addClass('couponPrices');
                                    $(this).addClass('haveCoupon');
                                    if ($(this).find('.prices .price').text().includes('od')) {
                                        $(this).find('.p-bottom .prices').prepend('<div class="customCode"><span class="couponPrice"><small>od </small>' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> <br>s kódem: <span class="cupounCode">' + couponData.code + '</span></div>');
                                    } else {
                                        $(this).find('.p-bottom .prices').prepend('<div class="customCode"><span class="couponPrice">' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> <br>s kódem: <span class="cupounCode">' + couponData.code + '</span></div>');
                                    }
                                }
                            });

                            if ($('.p-info-wrapper, .p-data-wrapper').length) {
                                var currentDate = new Date(); 
                                var validFrom = new Date(parseDate(couponData.validFrom));
                                var validUntil = new Date(parseDate(couponData.validUntil));

                                if (currentDate >= validFrom && currentDate <= validUntil) {
                                    $('.add-to-cart-wrapper').addClass('haveCoupon');
                                    var price = parseFloat($('.p-final-price-wrapper .price-final>span:not(.nodisplay)').text().replace(',', '.').replace(/ /g, ''));

                                    var CuponPrice;
                                    if (couponData.type === 'percentual') {
                                        CuponPrice = parseFloat(price) - ((parseFloat(couponData.discount) / 100) * parseFloat(price));
                                    } else {
                                        CuponPrice = parseFloat(price) - parseFloat(couponData.discount);
                                    }

                                    if ($('.variant-list').length > 0) {
                                        $('.add-to-cart-wrapper').append('<div class="customCode"><span class="priceCupon"><small>od </small>' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> Cena s kódem: <strong>' + couponData.code + '</strong></div>');
                                        document.addEventListener('shoptet.surcharges.updatePrices', function() {
                                            setTimeout(function() {
                                                var price = parseFloat($('.p-info-wrapper .p-final-price-wrapper .price-final>span:not(.noDisplay)').text().replace(',', '.').replace(/ /g, '').replace('/ks', ''));
                                                var CuponPrice = parseFloat(price) - parseFloat(couponData.discount);
                                                $('.priceCupon').html(Number(CuponPrice).ShoptetFormatAsCurrency());
                                            }, 250);
                                        });
                                    } else {
                                        $('.add-to-cart-wrapper').append('<div class="customCode"><span class="priceCupon"><small>od </small>' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> Cena s kódem: <strong>' + couponData.code + '</strong></div>');
                                    }
                                }
                            }
                        }
                        else{
                            var alreadyDisplayedCupon = false;
                            $('.products .product').each(function() {
                                if ($(this).find('.customCode').length > 0) {
                                    alreadyDisplayedCupon = true;
                                    return false;
                                }
                            });

                            if (alreadyDisplayedCupon) {
                                continue;
                            }

                            $('.products .product').each(function() {
                                var $product = $(this);
                                var productSKU = $product.find('span[data-micro="sku"]').text().trim();
                           
                               
                                for (var couponCode in storedData) {
                                    var couponData = storedData[couponCode];
                                    var validFrom = new Date(parseDate(couponData.validFrom));
                                    var validUntil = new Date(parseDate(couponData.validUntil));
                                    var currentDate = new Date(); 
                                    var price = $(this).find('div[data-micro="offer"]').attr('data-micro-price');
                                    
                                    if (couponData.product_codes.includes(productSKU)) {
                                        if (currentDate >= validFrom && currentDate <= validUntil) {
                                            var CuponPrice;
                                            if (couponData.type === 'percentual') {
                                                CuponPrice = parseFloat(price) - ((parseFloat(couponData.discount) / 100) * parseFloat(price));
                                            } else {
                                                CuponPrice = parseFloat(price) - parseFloat(couponData.discount);
                                            }
        
                                            $(this).find('.prices').addClass('couponPrices');
                                            $(this).addClass('haveCoupon');
                                            if ($(this).find('.prices .price').text().includes('od')) {
                                                $(this).find('.p-bottom .prices').prepend('<div class="customCode"><span class="couponPrice"><small>od </small>' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> <br>s kódem: <span class="cupounCode">' + couponData.code + '</span></div>');
                                            } else {
                                                $(this).find('.p-bottom .prices').prepend('<div class="customCode"><span class="couponPrice">' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> <br>s kódem: <span class="cupounCode">' + couponData.code + '</span></div>');
                                            }
                                        }
                                    }
                                }
                            });

                            if ($('.p-info-wrapper, .p-data-wrapper').length) {
                                productSKU = $('meta[itemprop="sku"]').attr('content').trim()
                                for (var couponCode in storedData) {
                                    var currentDate = new Date(); 
                                    var validFrom = new Date(parseDate(couponData.validFrom));
                                    var validUntil = new Date(parseDate(couponData.validUntil));
                                    if (couponData.product_codes.includes(productSKU)) {
                                        console.log( currentDate+' - '+validFrom)
                                        console.log( currentDate+' - '+validUntil)
                                        if (currentDate >= validFrom && currentDate <= validUntil) {
                                            
                                            console.log('Kupón je platný');
                                            $('.add-to-cart-wrapper').addClass('haveCoupon');
                                            var price = parseFloat($('.p-final-price-wrapper .price-final>span:not(.nodisplay)').text().replace(',', '.').replace(/ /g, ''));
        
                                            var CuponPrice;
                                            if (couponData.type === 'percentual') {
                                                CuponPrice = parseFloat(price) - ((parseFloat(couponData.discount) / 100) * parseFloat(price));
                                            } else {
                                                CuponPrice = parseFloat(price) - parseFloat(couponData.discount);
                                            }
        
                                            if ($('.variant-list').length > 0) {
                                                $('.add-to-cart-wrapper').append('<div class="customCode"><span class="priceCupon"><small>od </small>' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> Cena s kódem: <strong>' + couponData.code + '</strong></div>');
                                                document.addEventListener('shoptet.surcharges.updatePrices', function() {
                                                    setTimeout(function() {
                                                        var price = parseFloat($('.p-info-wrapper .p-final-price-wrapper .price-final>span:not(.noDisplay)').text().replace(',', '.').replace(/ /g, '').replace('/ks', ''));
                                                        var CuponPrice = parseFloat(price) - parseFloat(couponData.discount);
                                                        $('.priceCupon').html(Number(CuponPrice).ShoptetFormatAsCurrency());
                                                    }, 250);
                                                });
                                            } else {
                                                $('.add-to-cart-wrapper').append('<div class="customCode"><span class="priceCupon"><small>od </small>' + Number(CuponPrice).ShoptetFormatAsCurrency() + '</span> Cena s kódem: <strong>' + couponData.code + '</strong></div>');
                                            }
                                        }
                                        else{
                                            console.log('Kupón není platný');
                                        }
                                    }


                                }
                                
                            }

                        }
                    }
                } else {
                    console.error('Storage neobsahuje žádná data.');
                }
            }

            checkCouponCategory();

            document.addEventListener('ShoptetDOMContentLoaded', function() {
                checkCouponCategory()
            });
            document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
                checkCouponCategory()
            });

        }).fail(function() {
            console.error('Chyba při načítání JSON souboru.');
        });
    });
}
